import jwt_decode from "jwt-decode";

import { ApiError } from "@utils/custom-errors";
import { ENV_DOMAIN } from "@constants/domain";
import { SYPI_BRC } from "@constants/schema-management";

export const getSyPICommercialAPIConfig = () => {
  const schemaManagementClient = getJWT().schema_management_client;
  const isCommercial = schemaManagementClient === SYPI_BRC ? "/commercial" : "";
  return {
    isCommercial,
    BRCRoute: isCommercial ? `/commercial/${localStorage.ctid}` : "",
  };
};

export function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value.split("#")[0];
    }
  );
  return vars;
}

export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  //    can't set cookies currently.  for some reason, the user can't log in when cookies are set.
  //    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name) {
  document.cookie = name + "=; Max-Age=-99999999;";
}

export function convertQueryObjToString(query = {}, checkStatusParam = false) {
  // checkStatusParam: look for key that contains status,
  // TODO: checkStatusParam default to true once infrastructure for /live and /expired end pts are created across api
  let itemStatus = "";
  if (checkStatusParam) {
    let statusKey = Object.keys(query).filter(
      (key) => ~key.toLowerCase().indexOf("status")
    )[0];
    itemStatus = statusKey
      ? ["live", "expired"].includes(query[statusKey])
        ? query[statusKey]
        : ""
      : "";
    query = (({ [statusKey]: _, ...otherKeys }) => ({ ...otherKeys }))(query);
  }
  return `${itemStatus ? `/${itemStatus}` : ""}${
    !Object.keys(query).length
      ? ""
      : "?" +
        Object.keys(query)
          .reduce(
            (accumulator, key) => accumulator + `${key}=${query[key]}&`,
            ""
          )
          .slice(0, -1)
  }`;
}

export function gaTag() {
  let ctid = localStorage.getItem("ctid") || "";

  return ctid;
}

export const getJWT = () => {
  let JWT_TOKEN = localStorage.getItem("jwt") || "";
  return JWT_TOKEN ? jwt_decode(JWT_TOKEN) : {};
};

export const getBrowserParams = (searchString) => {
  let pairParams = {};
  if (searchString && searchString.length) {
    let entries = new URLSearchParams(searchString).entries();
    for (let pair of entries) {
      pairParams = { ...pairParams, [pair[0]]: pair[1] };
    }
  }
  return pairParams;
};

export const getSamlLoginRoute = () => {
  const LOGIN_ROUTE =
    ENV_DOMAIN[
      process.env.REACT_APP_WORKING_ENV.toString().toLocaleUpperCase()
    ];
  const subHostName = location.hostname.split(LOGIN_ROUTE)[0];
  return `${process.env.REACT_APP_API_LOGIN_ROUTE}/api/saml?url=${location.pathname}&host=${subHostName}`;
};

// a function to get the proper api route
export function getAPIConfig(
  route,
  includeCTID = true,
  includeReleaseId = false,
  customRoute = false
) {
  // API_URL can be overwritten by API_URL_OVERRIDE, defined in webpack.config by the value in .env
  //
  // CTID / JWT_TOKEN
  // for typical builds, these are written to local storage during the login process
  //
  // for test builds, local storage is created in test/test-helpers.js

  let CTID = localStorage.getItem("ctid") || "",
    JWT_TOKEN = localStorage.getItem("jwt") || "";

  let JWT_DECODED = JWT_TOKEN ? jwt_decode(JWT_TOKEN) : null;
  let subUrl = includeCTID
    ? `/api/2500/${CTID}${route}`
    : customRoute
      ? route
      : `/api${includeReleaseId ? `/2500` : ""}${route}`;
  let url = `${
    process.env.API_URL_OVERRIDE ? process.env.API_URL_OVERRIDE : ""
  }${subUrl}`;

  // if this is a test, use a simplified api url
  if (process.env.TEST_TYPE === "unit-with-mock") {
    url = `${
      process.env.API_URL_OVERRIDE ? process.env.API_URL_OVERRIDE : subUrl
    }`;
  }

  let absoluteUrl = `${
    process.env.API_URL_OVERRIDE
      ? process.env.API_URL_OVERRIDE
      : window.location.protocol + "//" + window.location.hostname
  }${subUrl}`;

  return {
    ctid: CTID,
    jwtToken: JWT_TOKEN,
    retailerId: (JWT_DECODED || {}).retailer_id,
    url: url,
    absoluteUrl: absoluteUrl,
  };
}

export function getMobileAPIConfig(route) {
  const CTID = localStorage.getItem("ctid") || "",
    JWT_TOKEN = localStorage.getItem("jwt") || "";
  let JWT_DECODED = JWT_TOKEN ? jwt_decode(JWT_TOKEN) : null;
  let url = `${
    process.env.MOBILE_API_URL
      ? process.env.MOBILE_API_URL
      : process.env.FALLBACK_MOBILE_API_URL
  }/${CTID}/1/5200/${route}`;

  return {
    ctid: CTID,
    jwtToken: JWT_TOKEN,
    retailerId: (JWT_DECODED || {}).retailer_id,
    url: url,
    absoluteUrl: url,
  };
}

export function handleAPIResponse(
  responseData,
  returnInsteadOfErr,
  returnFullError = false
) {
  try {
    // account for case where status is property of response call TODO: refactor Notifications endpt
    if (
      (responseData.hasOwnProperty("status") &&
        typeof responseData.status === "number" &&
        responseData.status !== 200 &&
        !returnFullError) ||
      // legacy error cases
      responseData.hasOwnProperty("apiError") ||
      (responseData.hasOwnProperty("messages") && responseData.messages.length)
    ) {
      throw new ApiError(responseData);
    }
    return responseData;
  } catch (err) {
    window.NREUM?.noticeError(err);
    console.warn(err.message);
    return returnInsteadOfErr ? returnInsteadOfErr : err.message;
  }
}

export const concurrencyBatchCall = async (
  listOfArguments,
  asyncOperation,
  concurrencyLimit = 10,
  logArgValue = false,
  callWithoutArgs = false
) => {
  const argsCopy = [].concat(listOfArguments.map((val, ind) => ({ val, ind })));
  const result = new Array(listOfArguments.length);
  const promises = new Array(concurrencyLimit).fill(Promise.resolve());
  // Recursively chain the next Promise to the currently executed Promise
  function chainNext(promise) {
    if (argsCopy.length) {
      const arg = argsCopy.shift();
      return promise.then(() => {
        // Store the result into the array upon Promise completion
        const operationPromise = asyncOperation(
          !callWithoutArgs ? arg.val : null
        ).then((r) => {
          result[arg.ind] = logArgValue ? { ...r, val: arg.val } : r;
        });
        return chainNext(operationPromise);
      });
    }
    return promise;
  }

  await Promise.all(promises.map(chainNext));
  return result;
};

// Opera 8.0+
export const isOpera = () =>
  (!!window.opr && !!opr.addons) ||
  !!window.opera ||
  navigator.userAgent.indexOf(" OPR/") >= 0;

// Firefox 1.0+
export const isFirefox = () => typeof InstallTrigger !== "undefined";

// Safari 3.0+ "[object HTMLElementConstructor]"
export const isSafari = () =>
  navigator.userAgent.indexOf("Firefox") > -1 ||
  /constructor/i.test(window.HTMLElement) ||
  (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(
    !window["safari"] ||
      (typeof safari !== "undefined" && safari.pushNotification)
  );

// Internet Explorer 6-11
export const isIE = () => /*@cc_on!@*/ false || !!document.documentMode;

// Edge 20+
export const isEdge = () => !isIE && !!window.StyleMedia;

// Chrome 1 - 71+
export const isChrome = () =>
  navigator.userAgent.indexOf("Chrome") > -1 ||
  (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime));

// Blink engine detection
export const isBlink = () => (isChrome || isOpera) && !!window.CSS;

export const generateCVS = (headers, csvObjectFile) => {
  let updatedCSVFormat = convertObjectToCVS(headers, csvObjectFile);
  downloadCSVFile(updatedCSVFormat);
};

export const convertObjectToCVS = (headers, csvObjectFile) => {
  let csvRows = [];

  let updatedHeaders = headers.reduce((accHeader, header) => {
    accHeader.push(header.label);
    return accHeader;
  }, []);
  csvRows.push(updatedHeaders.join(","));

  csvObjectFile.forEach((row) => {
    let updatedHeaders = headers.reduce((accHeader, header) => {
      let escapedStr = `${row[header.key]}`.replace(/"/g, '\\"');
      accHeader.push(`"${escapedStr}"`);
      return accHeader;
    }, []);
    csvRows.push(updatedHeaders.join(","));
  }, []);
  return csvRows.join("\n");
};

export const downloadCSVFile = (csvFile) => {
  const blob = new Blob([csvFile], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  let anchorTag = document.createElement("a");
  anchorTag.setAttribute("hidden", "");
  anchorTag.setAttribute("href", url);
  anchorTag.setAttribute("download", "app-feedback-export.csv");
  anchorTag.click();
};

export const getFileManagerRoute = (path, includeCTID = true, params = "") => {
  let customRoute = process.env.FM3_API_URL_OVERRIDE;
  let CTID = includeCTID ? localStorage.getItem("ctid") : "";
  return `${customRoute}${path}${CTID}${params}`;
};
